<div class="response table-responsive m-b-2">
    @if(response?.amenities?.length){    
        <app-nearby-amenities [amenities]="response?.amenities"></app-nearby-amenities>
    }
    @if(response?.roads?.length){
        <app-nearby-roads [roads]="response?.roads"></app-nearby-roads>
    }
</div>